<template>
    <transition name="fade">
        <span v-if="display && fadeTransition" class="success-checkmark">✅</span>
    </transition>
    <span v-if="display && !fadeTransition" class="success-checkmark">✅</span>
</template>

<script>
export default {
    name: 'SuccessCheckmark',
    props: {
        display: {
            type: Boolean,
            required: true,
        },
        fadeTransition: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {};
    },
    methods: {},
};
</script>

<style scoped>
.success-checkmark {
    font-size: 1.5em;
    margin-left: 2px;
    display: inline-block;
    /* Needed for transitions */
    vertical-align: middle;
    /* Align with button */
}

/* --- Fade Transition --- */
.fade-enter-from {
    opacity: 0;
}

.fade-leave-to {
    opacity: 0;
}

.fade-enter-active {
    transition: opacity 0.5s ease-out;
    /* Fade in quickly */
}

.fade-leave-active {
    transition: opacity 1s ease-in 4s;
    /* Start fading out after 4s (total 5s visibility), take 1s to fade */
}

/* --- End Fade Transition --- */
</style>
